import { useEffect, useState } from 'react';

const DEFAULT_LOCALE = 'en-US';

const Locales = [
    'de',
    'de-AT',
    'de-CH',
    'de-DE',
    'en-NZ',
    'en-AU',
    'en-IE',
    'en-SG',
    'en-HK',
    'en-DK',
    'en-FI',
    'en-GB',
    'en-CA',
    'en-US',
    'en',
    'es',
    'es-AR',
    'es-CL',
    'es-CO',
    'es-PE',
    'es-ES',
    'es-MX',
    'fr',
    'fr-BE',
    'fr-CH',
    'fr-FR',
    'fr-CA',
    'it',
    'it-IT',
    'nl',
    'nl-BE',
    'nl-NL',
    'pt-BR',
    'pt-PT',
    'pt',
    'sv',
];

export const useDefaultLocale = (locale?: string) => {
    const [browserLocale, setLocale] = useState(getLocale(locale));

    useEffect(() => {
        if (
            (locale === undefined || locale === '') &&
            typeof navigator !== 'undefined'
        ) {
            setLocale(getLocale(navigator.language));
        }
    }, [locale]);

    return browserLocale;
};

const getLocale = (locale?: string) => {
    if (!locale) {
        return DEFAULT_LOCALE;
    }

    return [locale.substring(0, 2), locale].reduce(
        (acc, currentLocaleOption) => {
            if (
                Locales.findIndex(
                    (supportedLocale) =>
                        supportedLocale === currentLocaleOption,
                ) !== -1
            ) {
                return currentLocaleOption;
            }

            return acc;
        },
        DEFAULT_LOCALE,
    );
};
